module.exports = __webpack_public_path__ + "static/create-min-min-8c52eacd355d3e17268c1ce560b31593.png";